import { IRevenueSpendListTableLang } from '../../../types/lang'

export const revenueSpendListTableLang: IRevenueSpendListTableLang = {
	revenue_spend_list_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_date_updated: 'Date Updated',
		column_amount: 'Amount',
		column_account_id: 'Account ID',
		column_account: 'Account',
		column_account_in_group: 'Account in Group',
		column_kt_group: 'KT Group',
		column_agency_id: 'Agency ID',
		column_agency: 'Agency',
		column_history: 'History',
		column_notes: 'Notes'
	}
}